import React from "react";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import SimpleTemplate from "@insightfulscience/atomic-react/SimpleTemplate";
import Heading from "@insightfulscience/atomic-react/Heading";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Alert from "@insightfulscience/atomic-react/Alert";
import Link from "@insightfulscience/atomic-react/Link";
import { HubSpotForm } from "../../HubSpotForms";
import SiteLayout from "../../SiteLayout";
import { publicConfig } from "../../config";

function ContactPage() {
	const [t] = useLocale("contact");
	const { HUBSPOT_PORTAL_ID, HUBSPOT_CONTACT_FORM_ID } = publicConfig;
	return (
		<SiteLayout>
			<PageMeta title={t("META_TITLE")}>
				<PageMeta.Robots content="noindex, follow" />
			</PageMeta>
			<SimpleTemplate
				utility={{ bgColor: "black--02" }}
				cellWidth={7}
				paddingTop="pt-9 pt-9--md"
				paddingBottom="pb-18 pb-18--md"
				panelSizing={{ minH: 178 }}
			>
				<Row utility={{ justify: "center" }}>
					<Col sm={12} md={11}>
						<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }}>
							{t("TITLE")}
						</Heading>
					</Col>
				</Row>
				<Row spacing={{ my: 3 }}>
					<Col sm={12}>
						<Alert status="success">
							<Paragraph sx={{ textAlign: "center" }} spacing={{ my: 0 }}>
								{t("SUBTITLE.ITEM_1")}
							</Paragraph>
							<Paragraph sx={{ textAlign: "center" }} spacing={{ my: 0 }}>
								<b>{t("SUBTITLE.ITEM_2")}</b>{" "}
								<Link href="https://help.graphpad.com/hc/en-us/requests/new?ticket_form_id=360000552331">
									{t("SUBTITLE.ITEM_3")}
								</Link>
							</Paragraph>
						</Alert>
					</Col>
				</Row>
				<HubSpotForm
					target="hubspotContact"
					formId={HUBSPOT_CONTACT_FORM_ID}
					portalId={HUBSPOT_PORTAL_ID}
				/>
			</SimpleTemplate>
		</SiteLayout>
	);
}

export default ContactPage;
